var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-8 col-xxl-8"},[_c('ListWidget3')],1),_c('div',{staticClass:"col-xxl-4"},[_c('StatWidget7'),_c('Paper')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }